'use strict';

function ProjectStatusController(gettextCatalog) {
  // payment text translation

  this.getPaymentPendingStatusText = function () {
    return gettextCatalog.getString(
      "You can start contributing to this project <b>{{ date }}</b> when it becomes active. Until then, go to your church's website orsocial media page to see if they have other projects running right now.",
      {
        date: moment(this.project.startDate).from(moment()),
      }
    );
  };
  this.getPaymentInactiveSatusText = function () {
    return gettextCatalog.getString(
      "This project has either been deactivated or reached its end date and will no longer accept contributions. Go to your church's website or social media page to see if they have other projects running right now."
    );
  };
}
angular
  .module('cdPay.components.projectStatus', [])
  .component('cdProjectStatus', {
    templateUrl: 'components/project-status/project-status.html',
    bindings: {
      project: '<cdProject',
    },
    controller: ProjectStatusController,
  });
